import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Box, TableContainer, TextField, Typography, Stack, Table, TableHead, TableRow, TableCell, TableBody, Chip, Button } from '@mui/material';

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import CookieLoad from '../../util/CookieLoad';
import AttendanceModal from '../../Components/Modals/AttendanceModal';

// Individual Team Page - Student View
function StudentTeamView(props) {
    const [projectTitle, setProjectTitle] = useState('');
    const [projectSponsor, setProjectSponsor] = useState('');
    const [teamData, setTeamData] = useState([]);
    const [attendanceData, setAttendanceData] = useState({});
    const [user, setUser] = useState({});
    const [role, setRole] = useState("");
    const [editRole, setEditRole] = useState(false);
    const [attendanceOpen, setAttendanceOpen] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(-1);
    const [token, setToken] = useState({});

    const handleAttendanceOpen = () => setAttendanceOpen(true);
    const handleAttendanceClose = (attendance) => {
        if (attendance) {
            let updatedAttendance = attendanceData;
            updatedAttendance.totalMeetings++;
            for (const [key, value] of Object.entries(attendance)) {
                if (value)
                    updatedAttendance.users[key]++;
            }
            setAttendanceData(updatedAttendance);
        }
        setAttendanceOpen(false);
    };

    let navigate = useNavigate();

    async function saveRole(userIndex) {
        await fetch(`${process.env.REACT_APP_API_HOST}/api/user/setRole`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token.access_token}`,
            },
            body: JSON.stringify({
                "user_id": user.user_id,
                "role": role
            })
        });

        let members = teamData.members;
        members[userIndex].role = role;
        setTeamData({ ...teamData, members })
        setEditRole(false);
    }

    async function changePM(user_id) {
        let members = teamData.members;
        let PM = members.find((user) => user.is_pm);
        let newPM = members.find((user) => user.user_id === user_id);
        if (PM) PM.is_pm = false;
        newPM.is_pm = true;
        await fetch(`${process.env.REACT_APP_API_HOST}/api/groups/setProjectManager`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token.access_token}`,
            },
            body: JSON.stringify({
                "user_id": user_id,
                "last_user_id": PM ? PM.user_id : null,
            })
        });
        if (user.user_id !== user_id)
            setUser({...user, is_pm: false});
    }

    function setUserData(user, group) {
        const hasPM = group.members.find((member) => member.is_pm);
        if (user.role)
            setRole(user.role);
        if (user.user_id)
            setUser({ user_id: user.user_id, is_pm: hasPM ? user.is_pm : true });
    }

    // api call to get the users group data
    function loadTeamData(token) {
        fetch(`${process.env.REACT_APP_API_HOST}/api/groups/findGroup`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token.access_token}`,
            },
        })
            .then(res => res.json())
            .then(group => {
                const userdata = group.members.find((member) => member.user_id === group.user);
                setUserData(userdata, group);
                setTeamData(group);
                setProjectTitle(group.project.name);
                setProjectSponsor((!group.project.sponsor || group.project.sponsor === '') ? 'Unknown' : group.project.sponsor);
            })
            .catch(error => console.error(error))

        fetch(`${process.env.REACT_APP_API_HOST}/api/groups/attendanceStats`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then(res => res.json())
            .then(attendance => {
                setAttendanceData(attendance);
            })
            .catch(error => console.error(error))
    }

    useEffect(() => {
        CookieLoad();
        const token = JSON.parse(localStorage.getItem('user'));
        if (!token) {
            navigate("/");
        }
        setToken(token);
        loadTeamData(token);
    }, []);


    return (
        <Box>
            <DashboardNavbar userType='student' />
            <Stack spacing={2} sx={{ minWidth: 80, p: 2, mx: 10, mt: 5 }} align='center'>
                {/* Team View Page Title, Team # and Name */}
                <Typography variant='h4' align='center'>{projectTitle}</Typography>
                {/* Sponsor Subheading */}
                <Typography variant='h5' align='center'>Sponsor: {projectSponsor}</Typography>

                {/* table of team members, roles, and attendance */}
                <TableContainer sx={{ mt: 30 }} >
                    <Table sx={{ bgcolor: '#E9E9E9', maxWidth: 1200, mt: 5 }}>
                        <TableHead >
                            <TableRow >
                                {/* empty table cell for PM chip */}
                                <TableCell sx={{ width: '5%' }} />
                                <TableCell align='left' sx={{ fontWeight: 'bold', fontSize: 20, padding: 2 }}>Member:</TableCell>
                                <TableCell align='left' sx={{ fontWeight: 'bold', fontSize: 20, padding: 2 }}>Role:</TableCell>
                                <TableCell align='left' sx={{ fontWeight: 'bold', fontSize: 20, padding: 2 }}>Attendance:</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {teamData.members ? teamData.members.map((data, i) => (
                                <TableRow key={data.user_id}>
                                    <TableCell align='right' onMouseEnter={() => setHoveredRow(i)} onMouseLeave={() => setHoveredRow(-1)}>{
                                        data.is_pm ? <Chip label='PM' sx={{ bgcolor: '#FFC904', color: 'black', fontWeight: 'bold' }} /> :
                                        hoveredRow === i && user.is_pm ? <Chip label='PM' sx={{ bgcolor: '#FFC904', color: 'black', fontWeight: 'bold' }} onClick={() => changePM(data.user_id)}/>
                                        : null
                                    }</TableCell>
                                    <TableCell align='left'>{data.first_name + ' ' + data.last_name}</TableCell>
                                    <TableCell align='left'>
                                        <Stack direction="row" sx={{ alignItems: "center" }}>
                                            {editRole && data.user_id === user.user_id ?
                                                <TextField label="New Role" size="small" value={role} onChange={(event) => setRole(event.target.value)} />
                                                : (!data.role || !data.role === '') ? "Unassigned" : data.role}
                                            {data.user_id === user.user_id ?
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={editRole ? () => saveRole(i) : () => setEditRole(true)}
                                                    style={{ marginLeft: "15px" }}
                                                >
                                                    {editRole ? "Save" : "Edit"}
                                                </Button>
                                                : null}
                                        </Stack>
                                    </TableCell>
                                    <TableCell align='left'>{attendanceData.users && (attendanceData.users[data.user_id] + " / " + attendanceData.totalMeetings)}</TableCell>
                                </TableRow>
                            ))
                                : null}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Stack>
            <Stack direction='row' spacing={2} justifyContent='center'>
                <Button variant='contained' onClick={handleAttendanceOpen}>Attendance</Button>
                <AttendanceModal open={attendanceOpen} handleAttendanceClose={handleAttendanceClose} teamData={teamData} />
            </Stack>
        </Box>
    );
}

export default StudentTeamView;
